export default __webpack_public_path__ + "static/media/cloud-download.5f157a6c.svg";